export default __webpack_public_path__ + "static/media/el6.d4eb8abd.svg";